import React from "react";
import ProjectCard from "./AppComponents/ProjectCard";

import { Container, Row } from "react-bootstrap";

import project1 from "../assets/images/project-1.png";
import project2 from "../assets/images/project-2.png";
import project3 from "../assets/images/project-3.png";
import project4 from "../assets/images/project-4.png";
import project5 from "../assets/images/project-5.png";
import project6 from "../assets/images/project-6.png";
import project7 from "../assets/images/project-7.svg";

const AppProjects = () => {
  return (
    <div id="projects" className="d-flex justify-content-center">
      <Container className="text-light">
        <h3 className="text-accent">My Projects</h3>
        <hr />
        <Row className="w-100">
          <ProjectCard
            title="Web3 ICO App"
            desc="ICO App is a Crypto ICO Web3 app that allows user to buy newly created STKN Token (ERC20) in a ICO Website by virtue of Smart Contract."
            image={project1}
            liveUrl="https://cryptoicoapp.netlify.app/"
            srcUrl="https://github.com/kaamil-ahamadh/web3-ico-app"
          />

          <br />
          <ProjectCard
            title="Web3 Simple Stake App"
            desc="Simple Stake App is a Crypto Staking Web3 app that allows users to stake and unstake STKN Token (ERC20) bought from ICO Website."
            image={project2}
            liveUrl="https://simplestakeapp.netlify.app/"
            srcUrl="https://github.com/kaamil-ahamadh/web3-simple-stake-app"
          />

          <ProjectCard
            title="Play Videos Hub"
            desc="Play Videos Hub is a Hub for playing youtube videos."
            image={project3}
            liveUrl="https://playvideoshub.netlify.app/"
            srcUrl="https://github.com/kaamil-ahamadh/play-videos-hub"
          />

          <ProjectCard
            title="DMessage"
            desc="DMessage is a Web3 app that allows us to send messages in a decentralized manner by virtue of blockchain technology."
            image={project4}
            liveUrl="https://dmessage.netlify.app/"
            srcUrl="https://github.com/kaamil-ahamadh/web3-message-app"
          />

          <ProjectCard
            title="Crypto Live Price App"
            desc="Crypto Live Price App is an app to check live crypto currency prices."
            image={project5}
            liveUrl="https://cryptolivepriceapp.netlify.app/"
            srcUrl="https://github.com/kaamil-ahamadh/crypto-live-price-app"
          />

          <ProjectCard
            title="Advice App"
            desc="Advice App is an app to get random advices on the go."
            image={project6}
            liveUrl="https://kaamil-ahamadh.github.io/advice-app/"
            srcUrl="https://github.com/kaamil-ahamadh/advice-app"
          />

          <ProjectCard
            title="Shooter Game"
            desc="Shooter Game is a simple shooting game."
            image={project7}
            srcUrl="https://github.com/kaamil-ahamadh/shooter-game"
          />
        </Row>
      </Container>
    </div>
  );
};

export default AppProjects;
